/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type IngredientModalCreateMutationVariables = {|
  name: string
|};
export type IngredientModalCreateMutationResponse = {|
  +ingredientCreate: ?{|
    +ingredient: ?{|
      +name: string
    |}
  |}
|};
export type IngredientModalCreateMutation = {|
  variables: IngredientModalCreateMutationVariables,
  response: IngredientModalCreateMutationResponse,
|};
*/


/*
mutation IngredientModalCreateMutation(
  $name: String!
) {
  ingredientCreate(input: {name: $name}) {
    ingredient {
      name
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name",
    "type": "String!"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IngredientModalCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "IngredientCreatePayload",
        "kind": "LinkedField",
        "name": "ingredientCreate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "IngredientNode",
            "kind": "LinkedField",
            "name": "ingredient",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IngredientModalCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "IngredientCreatePayload",
        "kind": "LinkedField",
        "name": "ingredientCreate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "IngredientNode",
            "kind": "LinkedField",
            "name": "ingredient",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "IngredientModalCreateMutation",
    "operationKind": "mutation",
    "text": "mutation IngredientModalCreateMutation(\n  $name: String!\n) {\n  ingredientCreate(input: {name: $name}) {\n    ingredient {\n      name\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '03c34ff8ada7374fc2b8788ce7f859d2';

module.exports = node;
